import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { fetchMe } from '../features/authSlice';

export default function AdminRoute({ children }) {
  const dispatch = useDispatch();
  const token = useSelector((s) => s.auth.token);
  const isAdmin = useSelector((s) => s.auth.is_admin || s.auth.is_staff || s.auth.is_superuser);
  const initialized = useSelector((s) => s.auth.initialized);
  const loading = useSelector((s) => s.auth.loading);

  useEffect(() => {
    if (token && !initialized) {
      dispatch(fetchMe());
    }
  }, [token, initialized, dispatch]);

  if (!token) return <Navigate to="/" replace />;

  if (!initialized || loading) {
    return <div className="container py-5 text-center text-muted">Checking access…</div>;
  }

  return isAdmin ? children : <Navigate to="/" replace />;
}
